import {Record} from 'immutable';

export const Metric = Record({
  id: undefined,
  value: 0,
  timestamp: undefined,
  context: undefined,
});
